export * from './src/document-management-editor-deployments-v1-deployment-deployments.universal.js';
